/**
 * Lightning strikes on the weather map: the Blitzortung-style age ramp
 * (`ageScale`) and the maplibre symbol layer drawn from it (`symbolLayer`),
 * shared by the webapp and mobile.
 */
export * from './ageScale';
export * from './symbolLayer';
